module.exports = __webpack_public_path__ + "static/media/alby-icon.244412b8.svg";